import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import { Typography } from "@mui/material"

import OverviewCard, {
  overviewCardValueSx,
  overviewCardHelperTextSx,
} from "./OverviewCard"

const WorkProgressCard = ({ percentage, isLoading }) => (
  <OverviewCard
    iconPreset="workAdvancePercent"
    title={i18n.t("overview.workAdvanceRealCardTitle")}
    infoText={i18n.t("overview.workAdvanceTotalCardTooltip")}
    loading={isLoading}
    sx={{ width: "100%", height: "100%" }}
  >
    <Typography sx={overviewCardValueSx}>{percentage.toFixed(1)}%</Typography>
    <Typography variant="body2" sx={overviewCardHelperTextSx}>
      {i18n.t("overview.workAdvanceTotalCardHelper")}
    </Typography>
  </OverviewCard>
)

WorkProgressCard.propTypes = {
  percentage: PropTypes.number.isRequired,
  isLoading: PropTypes.bool,
}

WorkProgressCard.defaultProps = {
  isLoading: false,
}

export default WorkProgressCard
